import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Typography,
  Radio,
  FormControl,
  RadioGroup,
  FormControlLabel,
  CircularProgress,
} from '@mui/material'
import React, { useState } from 'react'
import { arraysHaveSameElements } from '../utils/utils'
import { userAssignmentService } from '../../../../../services/userAssignmentService'
import { useAuthContext } from '../../../../../hooks/useAuthContext'
import { formatUserDisplayName } from '../../../../../utility/userName'

const DuplicateAssignmentResolveModal = ({
  openDuplicateResolve,
  setOpenDuplicateResolve,
  duplicateAssignments,
  assignee,
  userAssignmentData = [],
  setUserAssignmentData,
  handleSelectCombinationModalClose,
  activityTemplateId,
}) => {
  const { user } = useAuthContext()

  const [selectedValues, setSelectedValues] = useState(duplicateAssignments.map(() => 'yes'))
  const [buttonLoading, setButtonLoading] = useState(false)

  const handleChange = (index) => (event) => {
    const newSelectedValues = [...selectedValues]
    newSelectedValues[index] = event.target.value
    setSelectedValues(newSelectedValues)
  }

  const handleModalClose = () => {
    if (!buttonLoading) {
      setOpenDuplicateResolve(false)
    }
  }

  const handleConfirm = async () => {
    setButtonLoading(true)
    let newUserAssignmentData = [...userAssignmentData]
    selectedValues.forEach((value, index) => {
      let assignment = duplicateAssignments[index]
      let updatedCurrentUserDataCombinationIds = []
      let currentUserAssignmentDatum = newUserAssignmentData.find(
        (datum) => datum.user_id == assignee.user_id
      )

      if (value == 'yes') {
        let userAssignmentDatum = newUserAssignmentData.find(
          (datum) => datum.user_id == assignment.user_id
        )
        let userAssignmentDataIds = userAssignmentDatum?.assignments?.data_ids

        if (userAssignmentDataIds) {
          userAssignmentDataIds = userAssignmentDataIds.filter(
            (data_ids) => !arraysHaveSameElements(data_ids, assignment.combinationIds)
          )

          newUserAssignmentData = newUserAssignmentData.map((datum) => {
            if (datum.user_id == userAssignmentDatum.user_id) {
              return {
                ...datum,
                assignments: { ...datum.assignments, data_ids: userAssignmentDataIds },
              }
            } else {
              return datum
            }
          })
        }
        updatedCurrentUserDataCombinationIds = assignment.currentUserDataCombinationIds
        if (index > 0) {
          updatedCurrentUserDataCombinationIds = currentUserAssignmentDatum.assignments.data_ids
        }
      }

      if (value == 'no') {
        let currentUserDataCombinationIds = assignment.currentUserDataCombinationIds

        if (index > 0) {
          currentUserDataCombinationIds = currentUserAssignmentDatum.assignments.data_ids
        }

        updatedCurrentUserDataCombinationIds = currentUserDataCombinationIds.filter(
          (data_ids) => !arraysHaveSameElements(data_ids, assignment.combinationIds)
        )
      }

      if (currentUserAssignmentDatum) {
        newUserAssignmentData = newUserAssignmentData.map((datum) => {
          if (datum.user_id == currentUserAssignmentDatum.user_id) {
            return {
              ...datum,
              assignments: {
                ...datum.assignments,
                data_ids: updatedCurrentUserDataCombinationIds,
              },
            }
          } else {
            return datum
          }
        })
      } else {
        newUserAssignmentData.push({
          ...newUserAssignmentData[0],
          user_id: assignee.user_id,
          assignments: {
            ...newUserAssignmentData[0].assignments,
            data_ids: updatedCurrentUserDataCombinationIds,
          },
        })
      }
    })
    await userAssignmentService.saveUserActivityAssignmentAndRemoveDuplicates(user, {
      activity_template_id: activityTemplateId,
      user_assignment_data: newUserAssignmentData,
    })
    setButtonLoading(false)
    setUserAssignmentData(newUserAssignmentData)
    handleModalClose()
    handleSelectCombinationModalClose()
  }

  return (
    <Dialog
      open={openDuplicateResolve}
      onClose={handleModalClose}
      fullWidth
      maxWidth="md"
      aria-labelledby="responsive-dialog-title"
    >
      <DialogTitle id="responsive-dialog-title">
        Duplicate assignment combinations detected and need to be resolved.{' '}
      </DialogTitle>

      <DialogContent>
        <div style={{ width: '100%' }}>
          {duplicateAssignments.map((duplicate, index) => (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '5px',
                borderBottom: 'solid .5px lightgray',
              }}
            >
              <div style={{ width: '60%' }}>
                <Typography variant="subtitle1">{duplicate.combinationValues}</Typography>
              </div>
              <div style={{ width: '40%' }}>
                <FormControl component="fieldset" key={index}>
                  <RadioGroup row value={selectedValues[index]} onChange={handleChange(index)}>
                    <FormControlLabel
                      value={'no'}
                      control={<Radio color="primary" size="small" />}
                      label={duplicate.user_name}
                    />
                    <FormControlLabel
                      value={'yes'}
                      control={<Radio color="primary" size="small" />}
                      label={formatUserDisplayName(assignee)}
                    />
                  </RadioGroup>
                </FormControl>
              </div>
            </div>
          ))}
        </div>
      </DialogContent>

      <DialogActions>
        <Button color="primary" variant="outlined" onClick={handleModalClose}>
          Cancel
        </Button>
        <Button
          color="primary"
          variant="contained"
          disabled={buttonLoading}
          onClick={handleConfirm}
        >
          {buttonLoading ? <CircularProgress size="23px" color="inherit" /> : <>Confirm</>}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DuplicateAssignmentResolveModal
